import { TBreakpoints, IMediaQuerie } from './IMediaQueries';

export const breakpoints: TBreakpoints = ['768px', '1024px', '1280px'];

export const mediaQueries: IMediaQuerie = {
  md: `@media screen and (min-width: ${breakpoints[0]})`,
  lg: `@media screen and (min-width: ${breakpoints[1]})`,
  xl: `@media screen and (min-width: ${breakpoints[2]})`,
};
